import React, { useEffect, useState } from 'react'
import { useAppEx, useTbViewStore } from '@vt/hooks'
import { pick, cloneDeep } from 'lodash-es'
import { listToTree } from '@ow/utils'
import { fetchOrgData } from '@vt/apis/lib-ex/v2/orgs'
import { SearchTree } from '@ow/comps'

const renderTitle = (item) => {
  if (item.count) {
    return <div>({item.count})</div>
  }
  return <div style={{ color: '#ccc' }}> (...)</div>
}

const treeDataAttach = (treeNode, otherData, typeConfig) => {
  const nodeKey = treeNode[typeConfig.uniqKey]
  console.log('nodeKey', nodeKey, treeNode)
  treeNode.count = otherData[nodeKey] || '0'
  if (Array.isArray(treeNode.children)) {
    treeNode.children.forEach((item) =>
      treeDataAttach(item, otherData, typeConfig)
    )
  }
}

const typeMap = {
  area: {
    uniqKey: 'objectId',
    keyType: 'string',
    CountGroupName: 'area',
    treeDataType: 'list', // area从表单获取，为平铺结构数据
  },
  common: {
    uniqKey: 'id',
    keyType: 'number',
    CountGroupName: 'partiedOrg',
    fetchTreeData: fetchOrgData,
    treeDataType: 'tree', // 默认为树形结构数据
  },
}

const TreeSelect = function ({ type = 'area' }) {
  // const [data, setData] = useState([])
  const [treeData, setTreeData] = useState([])
  const typeConfig = typeMap[type]

  const { getDitto, appId } = useAppEx((state) =>
    pick(state, ['getDitto', 'appId'])
  )

  const { clickedInfo, filters, setFilters, ditto, setClickedInfo } =
    useTbViewStore((state) =>
      pick(state, [
        'clickedInfo',
        'filters',
        'setFilters',
        'ditto',
        'setClickedInfo',
      ])
    )
  const { clickedId = null } = clickedInfo

  // 单独获取属性结构，节点对应数据量
  const fetchCount = async (filter, _data) => {
    const _treeData = cloneDeep(_data)
    if (filter.childQueries && filter.childQueries.length !== 0) {
      return
    }
    const count = await ditto.fetchCountGroupBy(typeConfig.CountGroupName, {
      filters: filter,
    })
    _treeData.forEach((node) =>
      treeDataAttach(node, count[typeConfig.CountGroupName], typeConfig)
    )
    console.log('tree', _treeData)

    setTreeData(_treeData)
  }

  const fetchData = async () => {
    let _data = []
    if (_data.length === 0) {
      if (type === 'area') {
        const listData = await getDitto('area').fetchTbData({ pageSize: 10000 })
        _data = listToTree(
          listData.map((v) => {
            return { ...v, id: v.objectId }
          })
        )
      }
      if (typeConfig.fetchTreeData) {
        _data = await typeConfig.fetchTreeData(appId)
      }
    }
    console.log('_data', _data)
    fetchCount(filters, _data)
    setTreeData(_data)
  }
  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    const queries = {
      logicType: 'and',
      queries: [
        {
          slug: typeConfig.CountGroupName,
          value:
            typeConfig.keyType === 'number'
              ? parseInt(clickedId, 10)
              : clickedId,
          queryType: ['equal'],
        },
      ],
    }
    if (clickedId) {
      setFilters(queries)
    } else if (Object.keys(filters).length !== 0) {
      const _queries = filters.queries.filter((que) => {
        return que.slug !== typeConfig.CountGroupName
      })
      filters.queries = _queries
      setFilters(filters)
    }
  }, [clickedId])

  return (
    <div style={{ width: '100%', height: '100%' }} className="pt-4">
      <SearchTree
        data={treeData}
        label="title"
        ckey={typeConfig.uniqKey}
        titleLength={50}
        height="calc(100vh - 290px)"
        otherTitle={(item) => {
          return renderTitle(item)
        }}
        onSelect={(key) => {
          setClickedInfo({
            ...clickedInfo,
            clickedId: key[0] || null,
          })
        }}
      />
    </div>
  )
}

export default TreeSelect
